<div>
  @if (showCreateUser) {
    <app-create-user (userInfo)="userInfo($event)"></app-create-user>
  }
  @if (showCreateUser) {
    <label>Select User( if user is not in list create new by  above + button)</label>
  }
  <span class="p-float-label required-field w-100s">
    <p-autoComplete #userautocom [(ngModel)]="selectedUser"  class="col-lg-12" [suggestions]="users" [multiple]="false" [forceSelection]="true" [dropdown]="false" [style]="{'width':'100%'}"
      [inputStyle]="{'width':'100%'}" [minLength]="2" unique="true" field="fullName" placeholder="Select User" (completeMethod)="onKeyInput($event)" (onClear)="onUserCleared($event)"
    (onSelect)="onUserSeleted($event?.value)" [showClear]="true"> </p-autoComplete>
  </span>
</div>
